(() => {
  if (window.sn17ProductInitialised) return;
  window.sn17ProductInitialised = true;
  const colours = {
    'bleu nuit': ['#293342', '#fff'], 'blanc craie': ['#f4f3f0', '#1f2837'],
    'gris galet': ['#899092', '#1f2837'], 'bleu faïence': ['#a9c6d9', '#1f2837'],
    'bleu franc': ['#526da1', '#fff'], 'rose poudré': ['#d2a4b2', '#1f2837'],
    'bleu azur': ['#82b9c5', '#1f2837'], 'bleu brume': ['#c1dbe0', '#1f2837'],
    'vert d’eau': ['#b0c6b5', '#1f2837'], 'pêche': ['#eab59e', '#1f2837'],
    'sable': ['#c6b699', '#1f2837'], 'vert fougère': ['#4e6f55', '#fff'],
    'jaune mimosa': ['#e6ca58', '#1f2837'], 'noir': ['#272a30', '#fff'],
    'ivoire': ['#ede8dd', '#1f2837'], 'vert tendre': ['#ced895', '#1f2837'],
    'vert céladon': ['#afc0ae', '#1f2837'], 'ardoise': ['#626b75', '#fff'],
    'lilas': ['#b8a4c8', '#1f2837'], 'gris chiné': ['#a9aaad', '#1f2837'],
    'gris perle': ['#c9cbcd', '#1f2837'], 'jaune pâle': ['#ece0a9', '#1f2837'],
    'anthracite': ['#555a61', '#fff'], 'brique': ['#b77367', '#1f2837'],
    'corail': ['#db9d96', '#1f2837']
  };

  class Sn17Product {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.variants = this.readJson('[data-sn17-variants]', []);
      this.mediaMap = this.readJson('[data-sn17-media-map]', {});
      this.strings = this.readJson('[data-sn17-strings]', {});
      if (!this.variants.length) return;
      this.variant = this.variants.find(v => String(v.id) === root.dataset.currentVariant) || this.variants[0];
      this.purchaseVariant = this.variant;
      this.packDiscountEligible = ['oreiller-deux-hauteurs', 'oreiller-ondule', 'coussin-de-corps'].includes(root.dataset.productHandle);
      this.quantityOffers = this.readJson('[data-sn42-config]', null);
      if (!Array.isArray(this.quantityOffers?.variants)) this.quantityOffers = null;
      this.offers = [...root.querySelectorAll('[data-sn41-offer]')].flatMap(card => {
        try {
          const variants = JSON.parse(card.querySelector('[data-sn41-variants]')?.textContent || '[]');
          if (!Array.isArray(variants) || !variants.length) return [];
          return [{ card, handle: card.dataset.handle, count: Number(card.dataset.count), label: card.dataset.countLabel, included: card.dataset.includedLabel, title: card.dataset.productTitle, variants }];
        } catch { return []; }
      });
      const requestedOffer = new URL(window.location.href).searchParams.get('lot');
      this.selectedOfferHandle = this.offers.some(offer => offer.handle === requestedOffer) ? requestedOffer : root.dataset.productHandle;
      this.fieldsets = [...root.querySelectorAll('[data-sn17-option-index]')];
      this.variantInput = root.querySelector('[data-sn17-variant-id]');
      this.quantity = root.querySelector('[data-sn17-quantity]');
      this.form = root.querySelector('product-form form');
      this.add = root.querySelector('[data-sn17-add]');
      this.sticky = root.querySelector('[data-sn17-sticky]');
      this.stickyAdd = root.querySelector('[data-sn17-sticky-add]');
      this.dialog = root.querySelector('[data-sn17-zoom]');
      this.mainImage = root.querySelector('[data-sn17-main-image]');
      this.mainButton = root.querySelector('[data-sn17-zoom-open]');
      this.thumbnails = root.querySelector('[data-sn17-thumbnails]');
      this.status = root.querySelector('[data-sn17-status]');
      this.photos = [];
      this.view = 0;
      this.previousFocus = null;
      this.swipe = null;
      this.swipeClickUntil = 0;
      this.swipeClickSurface = null;
      this.listeners();
      this.paintSwatches();
      this.variantInput.disabled = false;
      root.setAttribute('data-sn17-enhanced', 'true');
      this.applyVariant(this.variant, false, false);
      this.offers.forEach(offer => {
        offer.card.querySelector('[data-sn41-card]').hidden = false;
        offer.card.querySelector('[data-sn41-fallback]').hidden = true;
      });
      this.observeSticky();
    }

    readJson(selector, fallback) {
      try { return JSON.parse(this.root.querySelector(selector)?.textContent || 'null') || fallback; }
      catch { return fallback; }
    }

    listen(element, event, callback, options = {}) {
      element?.addEventListener(event, callback, { ...options, signal: this.abort.signal });
    }

    listeners() {
      this.listen(this.root, 'change', event => {
        if (event.target.matches('[data-sn17-option-value]')) this.chooseVariant();
        if (event.target.matches('[data-sn41-radio]')) this.selectOffer(event.target.value, true);
        if (event.target.matches('[data-sn42-radio]')) this.selectQuantityOffer(Number(event.target.value));
        if (event.target === this.quantity) this.commitQuantity();
      });
      this.listen(this.quantity, 'input', () => {
        this.quantityButtons();
        this.syncPurchaseTotals();
        this.announcePurchase();
      });
      this.listen(this.quantity, 'blur', () => this.commitQuantity());
      this.listen(this.root.querySelector('[data-sn17-quantity-minus]'), 'click', () => this.stepQuantity(-1));
      this.listen(this.root.querySelector('[data-sn17-quantity-plus]'), 'click', () => this.stepQuantity(1));
      this.listen(this.form, 'submit', event => {
        this.normaliseQuantity();
        if (!this.purchaseVariant?.available || !this.quantity.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.quantity.reportValidity();
        }
      }, { capture: true });
      this.listen(this.stickyAdd, 'click', () => {
        if (this.sticky.dataset.sn17StickyMode === 'choose') {
          this.chooseOffer();
          return;
        }
        if (this.add.disabled || this.add.getAttribute('aria-disabled') === 'true') return;
        if (this.form.requestSubmit) this.form.requestSubmit(this.add);
        else this.add.click();
      });
      this.listen(this.thumbnails, 'click', event => {
        const button = event.target.closest('[data-sn17-view]');
        if (button) this.showView(Number(button.dataset.sn17View), true);
      });
      this.listen(this.thumbnails, 'keydown', event => {
        const button = event.target.closest('[data-sn17-view]');
        if (!button || !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = Number(button.dataset.sn17View);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.photos.length - 1;
        else index += ['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1;
        this.showView(Math.max(0, Math.min(this.photos.length - 1, index)), true);
        this.thumbnails.querySelector(`[data-sn17-view="${this.view}"]`)?.focus();
      });
      this.listen(this.root.querySelector('[data-sn17-previous]'), 'click', () => this.showView(this.view - 1, true));
      this.listen(this.root.querySelector('[data-sn17-next]'), 'click', () => this.showView(this.view + 1, true));
      this.listen(this.root.querySelector('[data-sn17-story-view-grid]'), 'click', event => {
        const button = event.target.closest('[data-sn17-story-view]');
        if (!button) return;
        this.previousFocus = button;
        this.showView(Number(button.dataset.sn17StoryView), false);
        this.openZoom();
      });
      this.listen(this.root.querySelector('[data-sn17-zoom-previous]'), 'click', () => this.showView(this.view - 1, true));
      this.listen(this.root.querySelector('[data-sn17-zoom-next]'), 'click', () => this.showView(this.view + 1, true));
      [this.mainButton, this.root.querySelector('.sn17-zoom-canvas')].forEach(surface => {
        this.listen(surface, 'pointerdown', event => this.startSwipe(event, surface), { passive: true });
        this.listen(surface, 'pointermove', event => this.moveSwipe(event), { passive: true });
        this.listen(surface, 'pointerup', event => this.finishSwipe(event), { passive: true });
        ['pointercancel', 'lostpointercapture'].forEach(type => this.listen(surface, type, event => {
          if (this.swipe?.id === event.pointerId) this.cancelSwipe();
        }, { passive: true }));
        this.listen(surface, 'click', event => this.suppressSwipeClick(event, surface), { capture: true });
      });
      this.listen(this.mainButton, 'click', () => this.openZoom());
      this.listen(this.root.querySelector('[data-sn17-zoom-close]'), 'click', () => this.closeZoom());
      this.listen(this.dialog, 'click', event => { if (event.target === this.dialog) this.closeZoom(); });
      this.listen(this.dialog, 'close', () => {
        this.cancelSwipe();
        if (this.previousFocus && !this.previousFocus.hidden) this.previousFocus.focus();
        else this.thumbnails.querySelector('[aria-current="true"]')?.focus();
        this.updateSticky();
      });
      this.listen(this.dialog, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showView(this.view + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }
      });
      this.listen(window, 'popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = this.variants.find(v => String(v.id) === id);
        const requestedOffer = new URL(window.location.href).searchParams.get('lot');
        this.selectedOfferHandle = this.offers.some(offer => offer.handle === requestedOffer) ? requestedOffer : this.root.dataset.productHandle;
        if (variant) this.applyVariant(variant, false, true);
      });
      this.listen(this.mainImage, 'error', () => {
        this.root.querySelector('[data-sn17-placeholder]').hidden = false;
        this.mainButton.hidden = true;
        this.root.querySelector('[data-sn17-media-caption]').hidden = true;
      });
      this.addObserver = new MutationObserver(() => this.updateSticky());
      this.addObserver.observe(this.add, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    startSwipe(event, surface) {
      if (!['touch', 'pen'].includes(event.pointerType)) return;
      if (event.isPrimary === false) { this.cancelSwipe(); return; }
      if (event.button !== 0 || !this.photos.length || !window.matchMedia('(max-width: 989px)').matches) return;
      this.cancelSwipe();
      this.swipe = { id: event.pointerId, surface, x: event.clientX, y: event.clientY };
      try { surface.setPointerCapture?.(event.pointerId); } catch {}
    }

    moveSwipe(event) {
      if (this.swipe?.id !== event.pointerId) return;
      const x = Math.abs(event.clientX - this.swipe.x);
      const y = Math.abs(event.clientY - this.swipe.y);
      if (y >= 12 && y > x) this.cancelSwipe();
    }

    finishSwipe(event) {
      if (this.swipe?.id !== event.pointerId) return;
      const gesture = this.swipe;
      const x = event.clientX - gesture.x;
      const y = event.clientY - gesture.y;
      this.cancelSwipe(false);
      if (!window.matchMedia('(max-width: 989px)').matches || Math.abs(x) < 40 || Math.abs(x) < Math.abs(y) * 1.3) return;
      this.swipeClickUntil = Date.now() + 400;
      this.swipeClickSurface = gesture.surface;
      const index = Math.max(0, Math.min(this.photos.length - 1, this.view + (x < 0 ? 1 : -1)));
      if (index !== this.view) this.showView(index, true);
    }

    cancelSwipe(clearClick = true) {
      const gesture = this.swipe;
      this.swipe = null;
      if (gesture) {
        try {
          if (gesture.surface.hasPointerCapture?.(gesture.id)) gesture.surface.releasePointerCapture(gesture.id);
        } catch {}
      }
      if (clearClick) {
        this.swipeClickUntil = 0;
        this.swipeClickSurface = null;
      }
    }

    suppressSwipeClick(event, surface) {
      if (event.detail === 0 || this.swipeClickSurface !== surface || Date.now() > this.swipeClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.swipeClickUntil = 0;
      this.swipeClickSurface = null;
    }

    paintSwatches() {
      this.root.querySelectorAll('[data-sn17-colour]').forEach(chip => {
        const value = chip.dataset.sn17Colour.trim().toLocaleLowerCase('fr');
        const colour = colours[value];
        const label = chip.closest('label');
        label.title = chip.dataset.sn17Colour;
        if (!colour) { label.setAttribute('data-text-swatch', 'true'); return; }
        chip.style.setProperty('--sn17-swatch-colour', colour[0]);
        chip.style.setProperty('--sn17-chip-ink', colour[1]);
      });
    }

    selectedOptions() {
      return this.fieldsets.map(field => field.querySelector('input:checked')?.value);
    }

    chooseVariant() {
      const options = this.selectedOptions();
      const variant = this.variants.find(v => v.options.every((value, index) => value === options[index]));
      if (variant) this.applyVariant(variant, true, true);
    }

    applyVariant(variant, updateUrl, announce) {
      this.variant = variant;
      this.root.dataset.currentVariant = String(variant.id);
      this.fieldsets.forEach((field, index) => {
        field.querySelectorAll('input').forEach(input => {
          input.checked = input.value === variant.options[index];
          const options = [...variant.options];
          options[index] = input.value;
          input.disabled = !this.variants.some(v => v.options.every((value, position) => value === options[position]));
        });
        field.querySelector('[data-sn17-selected-option]').textContent = variant.options[index];
      });
      this.updateOffers();
      this.loadGallery(variant);
      this.applyPurchase(false);
      if (updateUrl) this.updateSelectionUrl();
      if (announce) this.announcePurchase();
      this.root.dispatchEvent(new CustomEvent('sn17:variant-change', { bubbles: true, detail: { variant } }));
    }

    textFromHtml(html) {
      const template = document.createElement('template');
      template.innerHTML = html;
      return template.content.textContent;
    }

    updateOffers() {
      this.offers.forEach(offer => {
        const exact = offer.variants.find(variant => variant.colour === this.variant.options[0]);
        offer.current = exact || null;
        const card = offer.card;
        const radio = card.querySelector('[data-sn41-radio]');
        radio.disabled = !exact?.available;
        radio.checked = offer.handle === this.selectedOfferHandle;
        card.querySelectorAll('[data-sn41-price]').forEach(price => { price.innerHTML = exact?.priceFormatted || '—'; });
        card.querySelectorAll('[data-sn41-state]').forEach(state => { state.textContent = !exact ? this.strings.colourUnavailable : exact.available ? '' : this.strings.soldOut; });
        card.querySelectorAll('[data-sn41-saving]').forEach(saving => {
          saving.hidden = !exact?.hasSaving;
          saving.innerHTML = exact?.hasSaving ? exact.savingFormatted : '';
        });
        card.querySelectorAll('[data-sn41-comparison]').forEach(comparison => {
          comparison.hidden = !exact?.hasSaving;
          const comparisonAmount = comparison.querySelector('[data-sn46-comparison-amount]');
          if (comparisonAmount) comparisonAmount.innerHTML = exact?.hasSaving ? exact.separateMoney : '';
          else comparison.textContent = exact?.hasSaving ? exact.separateFormatted : '';
        });
        card.querySelectorAll('[data-sn41-image]').forEach(image => {
          image.hidden = !exact?.imageSrc;
          if (exact?.imageSrc) image.src = exact.imageSrc;
          else image.removeAttribute('src');
        });
      });
      const colour = this.root.querySelector('[data-sn41-colour]');
      if (colour) colour.textContent = this.variant.options[0];
    }

    selectOffer(handle, updateUrl) {
      const offer = this.offers.find(item => item.handle === handle);
      if (!offer?.current?.available) return;
      this.selectedOfferHandle = handle;
      this.updateOffers();
      this.applyPurchase(true);
      if (updateUrl) this.updateSelectionUrl();
      this.announcePurchase();
    }

    applyPurchase(resetQuantity) {
      const offer = this.offers.find(item => item.handle === this.selectedOfferHandle);
      const variant = offer ? offer.current : this.variant;
      this.purchaseVariant = variant;
      const available = Boolean(variant?.available);
      const count = offer?.count || 1;
      const title = offer?.title;
      this.variantInput.value = variant?.id || '';
      this.variantInput.disabled = !variant;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.root.querySelectorAll('[data-sn17-price]').forEach(price => { price.innerHTML = variant?.priceFormatted || '—'; });
      this.root.querySelectorAll('[data-sn17-unit-price]').forEach(price => {
        price.textContent = this.textFromHtml(variant?.unitPriceFormatted || '');
        price.hidden = Boolean(offer) && count < 2 || !variant?.unitPriceFormatted;
      });
      const state = !variant ? this.strings.unavailable : available ? this.strings.available : this.strings.soldOut;
      const addLabel = !variant ? this.strings.unavailable : available ? this.strings.add : this.strings.soldOut;
      this.root.querySelector('[data-sn17-availability]').textContent = state;
      this.root.querySelector('[data-sn17-add-label]').textContent = addLabel;
      this.stickyAdd.textContent = addLabel;
      this.root.querySelector('[data-sn17-sticky-variant]').textContent = variant?.title || this.variant.title;
      const stickyTitle = this.root.querySelector('[data-sn41-sticky-title]');
      if (stickyTitle && title) stickyTitle.textContent = title;
      this.add.disabled = !available;
      this.add.toggleAttribute('data-unavailable', !available);
      if (!this.add.classList.contains('loading')) this.add.removeAttribute('aria-disabled');
      this.stickyAdd.disabled = !available || this.add.getAttribute('aria-disabled') === 'true';
      this.quantity.min = variant?.quantityMin || 1;
      this.quantity.step = variant?.quantityIncrement || 1;
      if (variant?.quantityMax != null && variant.quantityMax >= Number(this.quantity.min)) this.quantity.max = variant.quantityMax;
      else this.quantity.removeAttribute('max');
      if (resetQuantity) this.quantity.value = this.quantity.min;
      this.normaliseQuantity();
      this.showQuantityRule();
      const quantityLabel = this.root.querySelector('[data-sn41-quantity-label]');
      if (quantityLabel) quantityLabel.textContent = count > 1 ? this.strings.lotsLabel.replace('[count]', offer.label) : this.strings.quantityLabel;
      this.quantity.setAttribute('aria-label', quantityLabel?.textContent || this.strings.quantityLabel);
      if (offer) {
        this.root.querySelector('[data-sn17-quantity-minus]').setAttribute('aria-label', this.strings.decreaseOffer.replace('[offer]', offer.label));
        this.root.querySelector('[data-sn17-quantity-plus]').setAttribute('aria-label', this.strings.increaseOffer.replace('[offer]', offer.label));
      }
      this.syncPurchaseTotals();
      this.updateSticky();
    }

    offerQuantityContext(count, offer) {
      if (offer && count === 1) return this.strings.offerPriceContext.replace('[offer]', offer.label.toLocaleLowerCase('fr'));
      const template = offer?.count > 1
        ? this.strings.totalLots || 'Total pour [quantity] lots de [offer]'
        : offer
          ? this.strings.totalSingles || 'Total pour [quantity] oreillers'
          : this.strings.totalQuantity || 'Total pour [quantity] articles';
      return template.replace('[quantity]', count).replace('[offer]', offer?.label.toLocaleLowerCase('fr') || '');
    }

    syncPurchaseTotals() {
      if (this.quantityOffers) this.syncQuantityOffers();
      else {
        const variant = this.purchaseVariant;
        const offer = this.offers.find(item => item.handle === this.selectedOfferHandle);
        const count = Number(this.quantity.value);
        const displayCount = Number.isSafeInteger(count) && count > 0;
        const contextText = displayCount ? this.offerQuantityContext(count, offer) : '—';
        const money = variant && displayCount ? this.quantityOfferMoney(count) : '—';
        this.root.querySelectorAll('[data-sn17-price]').forEach(price => { price.textContent = money; });
        const summary = this.root.querySelector('[data-sn41-selection]');
        if (summary) {
          summary.hidden = !offer;
          const template = count === 1
            ? this.strings.selectedOffer
            : offer?.count > 1
              ? this.strings.selectedLots || 'Votre choix : [quantity] lots de [offer], [included] par lot.'
              : this.strings.selectedSingles || 'Votre choix : [quantity] oreillers, une housse incluse par oreiller.';
          summary.textContent = offer && displayCount
            ? template.replace('[quantity]', count).replace('[offer]', offer.label).replace('[included]', offer.included.toLocaleLowerCase('fr'))
            : '';
        }
        const context = this.root.querySelector('[data-sn41-price-context]');
        if (context) {
          context.hidden = !offer && count === 1;
          context.textContent = contextText;
        }
        this.root.querySelector('[data-sn17-sticky-variant]').textContent = `${contextText} · ${variant?.title || this.variant.title}`;
        this.add.disabled = !this.quantityOfferAllowed(count);
      }
      this.updateSticky();
      this.root.dispatchEvent(new CustomEvent('sn17:purchase-change', { bubbles: true, detail: { variant: this.purchaseVariant, productHandle: this.selectedOfferHandle || this.root.dataset.productHandle, quantity: Number(this.quantity.value) } }));
    }

    quantityOfferLabel(count) {
      return count === 1 ? this.quantityOffers.one : this.quantityOffers.many.replace('[count]', count);
    }

    quantityOfferAllowed(count) {
      const variant = this.purchaseVariant;
      const min = variant?.quantityMin || 1;
      const step = variant?.quantityIncrement || 1;
      const max = variant?.quantityMax;
      return Boolean(variant?.available) && Number.isSafeInteger(count) && count >= min && (count - min) % step === 0 && (max == null || count <= max);
    }

    quantityOfferMoney(count, data) {
      const saving = this.quantityOfferSaving(count);
      if (saving > 0) return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((this.purchaseVariant.price * count - saving) / 100);
      if (count >= 1 && count <= 3 && data?.totals?.[count - 1]) return this.textFromHtml(data.totals[count - 1]);
      if (count === 1 && this.purchaseVariant?.priceFormatted) return this.textFromHtml(this.purchaseVariant.priceFormatted);
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: this.quantityOffers?.currency || this.strings.currency || 'EUR' }).format(this.purchaseVariant.price * count / 100);
    }

    quantityOfferSaving(count) {
      const currency = this.quantityOffers?.currency || this.strings.currency || 'EUR';
      if (!this.packDiscountEligible || currency !== 'EUR' || this.purchaseVariant?.id !== this.variant.id || !Number.isSafeInteger(count) || count < 2) return 0;
      return Math.min(this.purchaseVariant.price * count, count * (count >= 3 ? 1330 : 995));
    }

    selectQuantityOffer(count) {
      if (!this.quantityOffers || !this.quantityOfferAllowed(count)) return;
      this.quantity.value = count;
      this.normaliseQuantity();
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      this.announcePurchase();
    }

    syncQuantityOffers() {
      if (!this.quantityOffers) return;
      const config = this.quantityOffers;
      const variant = this.purchaseVariant;
      const data = config.variants.find(item => String(item.id) === String(this.variant.id));
      const fieldset = this.root.querySelector('[data-sn42-offers]');
      if (!fieldset || !data || !variant) return;
      const count = Number(this.quantity.value);
      const valid = this.quantityOfferAllowed(count);
      const displayCount = Number.isSafeInteger(count) && count > 0;
      const unitMoney = this.textFromHtml(variant.priceFormatted);
      const each = config.each.replace('[price]', unitMoney);
      const rebuildImages = this.quantityImagesVariant !== this.variant.id;
      fieldset.querySelectorAll('[data-sn42-card]').forEach(card => {
        const amount = Number(card.dataset.count);
        const allowed = this.quantityOfferAllowed(amount);
        const radio = card.querySelector('[data-sn42-radio]');
        radio.disabled = !allowed;
        radio.checked = valid && count === amount;
        card.querySelector('[data-sn42-price]').textContent = this.quantityOfferMoney(amount, data);
        const saving = this.quantityOfferSaving(amount);
        const amountMoney = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: config.currency || 'EUR' });
        const eachAmount = saving > 0 ? amountMoney.format((variant.price * amount - saving) / amount / 100) : unitMoney;
        card.querySelector('[data-sn42-each]').textContent = config.each.replace('[price]', eachAmount);
        const comparison = card.querySelector('[data-sn75-quantity-comparison]');
        if (comparison) {
          comparison.hidden = saving <= 0;
          card.querySelector('[data-sn75-quantity-separate]').textContent = amountMoney.format(variant.price * amount / 100);
          card.querySelector('[data-sn75-quantity-saving]').textContent = (config.saving || '[amount]').replace('[amount]', amountMoney.format(saving / 100));
        }
        card.querySelector('[data-sn42-state]').textContent = allowed ? '' : config.unavailable;
        if (rebuildImages) {
          const media = card.querySelector('[data-sn42-media]');
          const fragment = document.createDocumentFragment();
          const images = Array.isArray(data.images) ? data.images.filter(image => typeof image.src === 'string' && image.src) : [];
          for (let index = 0; index < amount; index++) {
            const group = document.createElement('span');
            group.className = 'sn42-offer__unit';
            group.style.setProperty('--sn42-parts', images.length || 1);
            images.forEach(image => {
              const img = document.createElement('img');
              img.src = image.src;
              img.alt = image.alt || '';
              img.width = 96;
              img.height = 96;
              img.loading = 'lazy';
              img.decoding = 'async';
              group.append(img);
            });
            fragment.append(group);
          }
          media.replaceChildren(fragment);
        }
      });
      this.quantityImagesVariant = this.variant.id;
      fieldset.hidden = false;
      this.root.querySelectorAll('[data-sn17-price]').forEach(price => { price.textContent = displayCount ? this.quantityOfferMoney(count, data) : '—'; });
      const selectedUnit = displayCount ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: config.currency || 'EUR' }).format((variant.price * count - this.quantityOfferSaving(count)) / count / 100) : unitMoney;
      const selectedEach = config.each.replace('[price]', selectedUnit);
      this.root.querySelectorAll('[data-sn17-unit-price]').forEach(price => { price.textContent = selectedEach; price.hidden = !displayCount; });
      const quantityLabel = this.root.querySelector('[data-sn41-quantity-label]');
      quantityLabel.textContent = config.quantityLabel;
      this.quantity.setAttribute('aria-label', config.quantityLabel);
      const choice = displayCount ? this.quantityOfferLabel(count) : '—';
      fieldset.querySelector('[data-sn42-selection]').textContent = config.selected.replace('[quantity]', choice);
      fieldset.querySelector('[data-sn42-colours]').textContent = config.colours.replace('[colours]', this.variant.title);
      const context = this.root.querySelector('[data-sn41-price-context]');
      context.textContent = config.total.replace('[quantity]', choice);
      context.hidden = false;
      this.root.querySelector('[data-sn17-sticky-variant]').textContent = `${choice} · ${this.variant.title}`;
      this.add.disabled = !valid;
      this.stickyAdd.disabled = !valid || this.add.getAttribute('aria-disabled') === 'true';
    }

    updateSelectionUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.variant.id);
      if (this.offers.length && this.selectedOfferHandle !== this.root.dataset.productHandle) url.searchParams.set('lot', this.selectedOfferHandle);
      else url.searchParams.delete('lot');
      window.history.replaceState({}, '', url);
    }

    announcePurchase() {
      const offer = this.offers.find(item => item.handle === this.selectedOfferHandle);
      const variant = this.purchaseVariant;
      const count = Number(this.quantity.value);
      if (!Number.isSafeInteger(count) || count < 1) return;
      const state = !variant ? this.strings.unavailable : !variant.available ? this.strings.soldOut : this.quantityOfferAllowed(count) ? this.strings.available : this.strings.unavailable;
      if (this.quantityOffers) {
        const data = this.quantityOffers.variants.find(item => String(item.id) === String(this.variant.id));
        const message = `${this.quantityOfferLabel(count)} · ${this.variant.title} — ${this.quantityOfferMoney(count, data)} — ${state}`;
        if (this.status.textContent !== message) this.status.textContent = message;
        return;
      }
      const message = `${this.offerQuantityContext(count, offer)} · ${this.variant.title} — ${variant ? this.quantityOfferMoney(count) : '—'} — ${state}`;
      if (this.status.textContent !== message) this.status.textContent = message;
    }

    commitQuantity() {
      this.normaliseQuantity();
      this.announcePurchase();
    }

    normaliseQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let value = Number(this.quantity.value);
      if (!Number.isFinite(value) || value < min) value = min;
      value = min + Math.round((value - min) / step) * step;
      if (value > max) value = min + Math.floor((max - min) / step) * step;
      this.quantity.value = Math.max(min, value);
      this.quantityButtons();
      this.syncPurchaseTotals();
    }

    stepQuantity(direction) {
      this.normaliseQuantity();
      this.quantity.value = Number(this.quantity.value) + direction * (Number(this.quantity.step) || 1);
      this.normaliseQuantity();
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    quantityButtons() {
      const value = Number(this.quantity.value);
      this.root.querySelector('[data-sn17-quantity-minus]').disabled = value <= Number(this.quantity.min);
      this.root.querySelector('[data-sn17-quantity-plus]').disabled = this.quantity.max !== '' && value >= Number(this.quantity.max);
    }

    showQuantityRule() {
      const note = this.root.querySelector('[data-sn17-quantity-note]');
      const { quantityMin: min = 1, quantityMax: max = null, quantityIncrement: step = 1 } = this.purchaseVariant || {};
      note.hidden = min <= 1 && step <= 1 && max == null;
      note.textContent = (this.strings.quantityRule || '').replace('[min]', min).replace('[step]', step).replace('[max]', max == null ? '—' : max);
    }

    loadGallery(variant) {
      this.cancelSwipe();
      const media = this.mediaMap[String(variant.id)] || [];
      const coverOnly = this.root.dataset.coverOnly === 'true';
      this.photos = media.filter(photo => photo.src && typeof photo.src === 'string' && (!coverOnly || photo.role === 'studio' && photo.media_role === 'housse'));
      this.view = 0;
      const stickyImage = this.root.querySelector('[data-sn17-sticky-image]');
      const studio = this.photos.find(photo => photo.role === 'studio');
      stickyImage.hidden = !studio;
      if (studio) this.setResponsivePhoto(stickyImage, studio, '64px', [120, 240]);
      else { stickyImage.removeAttribute('src'); stickyImage.removeAttribute('srcset'); }
      this.updateUsage();
      this.updateEditorial();
      this.thumbnails.replaceChildren();
      this.thumbnails.hidden = this.photos.length < 2;
      this.root.querySelector('[data-sn17-gallery-arrows]').hidden = this.photos.length < 2;
      this.mainButton.hidden = this.photos.length === 0;
      this.root.querySelector('[data-sn17-placeholder]').hidden = this.photos.length > 0;
      this.root.querySelector('[data-sn17-media-caption]').hidden = this.photos.length === 0;
      if (!this.photos.length) {
        this.mainImage.removeAttribute('src');
        this.mainImage.removeAttribute('srcset');
        if (this.dialog.open) this.closeZoom();
        return;
      }
      const fragment = document.createDocumentFragment();
      this.photos.forEach((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sn17-thumbnail';
        button.dataset.sn17View = String(index);
        button.setAttribute('aria-label', `${this.strings.chooseView} ${index + 1} — ${this.strings[photo.role] || photo.alt}`);
        button.setAttribute('aria-controls', this.mainButton.closest('section').id);
        const img = document.createElement('img');
        this.setResponsivePhoto(img, photo, '66px', [120, 240]);
        img.alt = '';
        img.width = 66;
        img.height = 66;
        img.loading = 'lazy';
        img.decoding = 'async';
        button.append(img);
        fragment.append(button);
      });
      this.thumbnails.append(fragment);
      this.showView(0, false);
    }

    updateUsage() {
      const section = this.root.querySelector('[data-sn77-usage]');
      if (!section) return;
      const figure = section.querySelector('[data-sn77-figure]');
      const image = section.querySelector('[data-sn77-image]');
      const photo = this.photos.find(item => item.role === section.dataset.sn77Role)
        || this.photos.find(item => item.role === 'studio');
      figure.hidden = !photo;
      section.classList.toggle('sn77-usage--text-only', !photo);
      if (!photo) {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        return;
      }
      this.setResponsivePhoto(image, photo, '(min-width: 990px) 50vw, 100vw', [480, 720, 960, 1254]);
      image.alt = photo.alt || this.variant.title;
      image.width = photo.width || 1000;
      image.height = photo.height || 1000;
    }

    updateEditorial() {
      const story = this.root.querySelector('[data-sn17-product-story]');
      if (!story) return;
      const byRole = role => this.photos.find(photo => photo.role === role);
      const views = this.root.querySelector('[data-sn17-story-views]');
      const grid = this.root.querySelector('[data-sn17-story-view-grid]');
      const selected = ['studio', 'usage', 'matiere', 'illustration'].map(byRole).filter(Boolean);
      const showViews = selected.length > 1;
      views.hidden = !showViews;
      grid.replaceChildren();
      if (showViews) selected.forEach(photo => {
        const card = document.createElement('figure');
        card.className = 'sn17-story-view';
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.sn17StoryView = String(this.photos.indexOf(photo));
        button.setAttribute('aria-label', `${this.strings.chooseView} — ${this.strings[photo.role] || photo.alt}`);
        const image = document.createElement('img');
        this.setResponsivePhoto(image, photo, '(min-width: 990px) 25vw, (min-width: 750px) 50vw, 82vw', [360, 540, 750, 1000]);
        image.alt = photo.alt || this.variant.title;
        image.width = photo.width || 1000;
        image.height = photo.height || 1000;
        image.loading = 'lazy';
        image.decoding = 'async';
        button.append(image);
        const caption = document.createElement('figcaption');
        const label = document.createElement('strong');
        label.textContent = this.strings[photo.role] || photo.alt;
        caption.append(label);
        card.append(button, caption);
        grid.append(card);
      });
      grid.style.setProperty('--sn17-view-columns', String(Math.min(selected.length, 4)));
      this.root.querySelectorAll('[data-sn17-story-image]').forEach(image => {
        const photo = byRole(image.dataset.sn17StoryImage);
        if (photo) {
          this.setResponsivePhoto(image, photo, image.closest('nav') ? '64px' : '(min-width: 990px) 50vw, 100vw', image.closest('nav') ? [120, 240] : [480, 720, 960, 1254]);
          image.alt = image.closest('nav') ? '' : photo.alt || this.variant.title;
          image.width = photo.width || 1000;
          image.height = photo.height || 1000;
        } else { image.removeAttribute('src'); image.removeAttribute('srcset'); }
      });
      const usage = byRole('usage');
      const material = byRole('matiere');
      const legacyScene = this.root.querySelector('[data-sn17-story-scene]');
      if (legacyScene) legacyScene.hidden = !usage;
      this.root.querySelector('[data-sn17-story-material]').hidden = !material;
      story.hidden = !showViews && !usage && !material;
      const shortcuts = this.root.querySelector('[data-sn17-story-shortcuts]');
      shortcuts.hidden = story.hidden && !this.root.querySelector('[data-sn77-usage]');
      shortcuts.querySelectorAll('[data-sn17-shortcut]').forEach(link => {
        const role = link.dataset.sn17Shortcut;
        link.hidden = role === 'studio' ? !showViews : !byRole(role);
      });
      this.root.querySelectorAll('[data-sn17-story-colour]').forEach(label => { label.textContent = this.variant.title; });
    }

    setResponsivePhoto(image, photo, sizes, widths = [480, 720, 960, 1254]) {
      if (!image || !photo?.src) return;
      image.dataset.sn75OriginalSource = photo.src;
      image.decoding = 'async';
      try {
        const url = new URL(photo.src, window.location.href);
        const cdn = url.hostname === 'cdn.shopify.com' || (url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'));
        if (cdn) {
          const maximum = Number(photo.width) > 0 ? Number(photo.width) : widths[widths.length - 1];
          const candidates = [...new Set(widths.map(width => Math.min(width, maximum)))];
          const sourceAt = width => {
            const resized = new URL(url.href);
            resized.searchParams.set('width', String(width));
            return resized.href;
          };
          image.sizes = sizes;
          image.srcset = candidates.map(width => `${sourceAt(width)} ${width}w`).join(', ');
          image.src = sourceAt(Math.min(960, candidates[candidates.length - 1]));
          return;
        }
      } catch {}
      image.removeAttribute('srcset');
      image.src = photo.src;
    }

    optimiseEditorialImages() {
      this.root.querySelectorAll('[data-sn17-story-view-grid] img, [data-sn21-product-detail] img').forEach(image => {
        const source = image.dataset.sn75OriginalSource || image.getAttribute('src');
        const photo = this.photos.find(item => item.src === source);
        if (!photo) return;
        const detail = Boolean(image.closest('[data-sn21-product-detail]'));
        this.setResponsivePhoto(image, photo, detail ? '(min-width: 990px) 50vw, 100vw' : '(min-width: 990px) 25vw, (min-width: 750px) 50vw, 82vw', detail ? [480, 720, 960, 1254] : [360, 540, 750, 1000]);
      });
    }

    showView(index, announce) {
      if (!this.photos.length) return;
      this.view = Math.max(0, Math.min(this.photos.length - 1, index));
      const photo = this.photos[this.view];
      this.setResponsivePhoto(this.mainImage, photo, '(min-width: 1600px) 760px, (min-width: 990px) 50vw, calc(100vw - 40px)');
      this.mainImage.alt = photo.alt || this.variant.title;
      this.mainImage.width = photo.width || 1000;
      this.mainImage.height = photo.height || 1000;
      this.mainButton.hidden = false;
      this.root.querySelector('[data-sn17-placeholder]').hidden = true;
      this.root.querySelector('[data-sn17-media-caption]').hidden = false;
      const count = `${this.view + 1} / ${this.photos.length}`;
      const role = this.strings[photo.role] || '';
      this.root.querySelector('[data-sn17-view-count]').textContent = count;
      this.root.querySelector('[data-sn17-role-label]').textContent = role;
      this.thumbnails.querySelectorAll('button').forEach((button, number) => button.setAttribute('aria-current', String(number === this.view)));
      ['[data-sn17-previous]', '[data-sn17-zoom-previous]'].forEach(selector => { this.root.querySelector(selector).disabled = this.view === 0; });
      ['[data-sn17-next]', '[data-sn17-zoom-next]'].forEach(selector => { this.root.querySelector(selector).disabled = this.view === this.photos.length - 1; });
      if (this.dialog.open) this.updateZoom();
      if (announce) this.status.textContent = `${this.strings.chooseView} ${count} — ${role}`;
    }

    updateZoom() {
      const photo = this.photos[this.view];
      const image = this.root.querySelector('[data-sn17-zoom-image]');
      image.src = photo.src;
      image.alt = photo.alt || this.variant.title;
      image.width = photo.width || 1000;
      image.height = photo.height || 1000;
      this.root.querySelector('[data-sn17-zoom-count]').textContent = `${this.view + 1} / ${this.photos.length}`;
      this.root.querySelector('[data-sn17-zoom-role]').textContent = this.strings[photo.role] || '';
    }

    openZoom() {
      if (!this.photos.length || typeof this.dialog.showModal !== 'function') return;
      this.previousFocus = document.activeElement;
      this.updateZoom();
      this.dialog.showModal();
      this.updateSticky();
      this.root.querySelector('[data-sn17-zoom-close]').focus();
    }

    closeZoom() { this.dialog.close(); }

    chooseOffer() {
      const target = [...this.root.querySelectorAll('[data-sn41-offers], [data-sn42-offers]')].find(field => !field.hidden && field.getClientRects().length)
        || this.root.querySelector('.sn45-purchase-panel') || this.form;
      if (!target) return;
      const focus = target.querySelector('input[data-sn41-radio]:checked:not(:disabled), input[data-sn42-radio]:checked:not(:disabled)')
        || target.querySelector('input[data-sn41-radio]:not(:disabled), input[data-sn42-radio]:not(:disabled)')
        || (!this.add.disabled ? this.add : target);
      if (focus === target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
      focus.focus({ preventScroll: true });
    }

    observeSticky() {
      this.stickyObserver = new IntersectionObserver(() => this.updateSticky(), { threshold: [0, 1] });
      this.stickyObserver.observe(this.add);
      const heading = this.root.querySelector('.sn17-buybox > h1');
      if (heading) this.stickyObserver.observe(heading);
      this.listen(window, 'resize', () => this.updateSticky());
      this.listen(window, 'scroll', () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          this.stickyFrame = null;
          this.updateSticky();
        });
      }, { passive: true });
      this.overlayObserver = new MutationObserver(() => this.updateSticky());
      this.overlayObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
      this.updateSticky();
    }

    updateSticky() {
      const rect = this.add.getBoundingClientRect();
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const viewportHeight = window.innerHeight;
      const heading = this.root.querySelector('.sn17-buybox > h1');
      const beforePurchase = mobile && heading && heading.getBoundingClientRect().top < viewportHeight && rect.top >= viewportHeight;
      const passedPurchase = rect.bottom <= 0;
      const overlay = [...document.querySelectorAll('dialog[open], cart-drawer.active .drawer__inner, cart-notification.active, details[open].menu-drawer-container, details[open] > .search-modal')]
        .some(node => node.getClientRects().length > 0 && window.getComputedStyle(node).visibility !== 'hidden');
      this.sticky.dataset.sn17StickyMode = beforePurchase ? 'choose' : 'add';
      this.sticky.hidden = overlay || !(beforePurchase || passedPurchase);
      this.stickyAdd.textContent = beforePurchase
        ? this.strings.chooseOffer || 'Choisir mon offre'
        : this.root.querySelector('[data-sn17-add-label]').textContent;
      this.stickyAdd.disabled = !beforePurchase && (this.add.disabled || this.add.getAttribute('aria-disabled') === 'true');
      const reserveSpace = mobile && !this.sticky.hidden;
      document.body.classList.toggle('sn17-mobile-buybar-space', reserveSpace);
      if (reserveSpace) document.body.style.setProperty('--sn17-buybar-height', `${Math.ceil(this.sticky.getBoundingClientRect().height)}px`);
      else document.body.style.removeProperty('--sn17-buybar-height');
    }

    destroy() {
      this.cancelSwipe();
      this.abort.abort();
      this.stickyObserver?.disconnect();
      if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      this.addObserver?.disconnect();
      this.overlayObserver?.disconnect();
      if (this.dialog?.open) this.closeZoom();
      document.body.classList.remove('sn17-mobile-buybar-space');
      document.body.style.removeProperty('--sn17-buybar-height');
    }
  }

  const instances = new Map();
  document.addEventListener('sn17:variant-change', event => {
    const root = event.target.closest?.('[data-sn17-product]');
    if (!root) return;
    queueMicrotask(() => instances.get(root.id)?.optimiseEditorialImages());
  });
  const initialise = scope => {
    scope.querySelectorAll('[data-sn17-product]').forEach(root => {
      if (instances.has(root.id)) return;
      instances.set(root.id, new Sn17Product(root));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sn17-product]').forEach(root => {
      instances.get(root.id)?.destroy();
      instances.delete(root.id);
    });
  });
})();
